export default __webpack_public_path__ + "static/media/star-empty.cc355ce0.svg";